module.exports = __webpack_public_path__ + "static/media/levAR_logo.8b2e0601.svg";